import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, IconButton } from '@mui/material';

export default function JumpToLatestButton({ onClick }: { onClick: () => void }) {
  return (
    <Box sx={{ position: 'sticky', bottom: 8, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
      <IconButton
        aria-label="Jump to latest"
        onClick={onClick}
        size="small"
        sx={{
          pointerEvents: 'auto',
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          boxShadow: 1,
          '&:hover': { bgcolor: 'background.paper' },
        }}
      >
        <KeyboardArrowDownIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
